import { observer } from 'mobx-react-lite'
import React from 'react'
import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit'
import Store from './../../store'

import './CreateEliteAgencyTeamButton.scss'

const CreateEliteAgencyTeamButton = props => (
  <MDBBtn
    type='button'
    color='info'
    disabled={Store.isFetching || !Store.canCreate()}
    id='CreateEliteAgencyTeamButtonComponent'
    onClick={() => Store.create()}
  >
    Create Elite Agency Team &nbsp;
    <MDBIcon icon='plus' />
  </MDBBtn>
)

export default observer(CreateEliteAgencyTeamButton)
